import { UpdateDealSetupNoteDocument } from '@/lib/graphql/generated/graphql';
import { dealAtom } from '@/states/deal.state';
import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';

import { useDealNotEditableHandler } from './useDealNotEditableHandler';

export function useUpdateDealSetupNote(dealId: string) {
  const { handleIfDealNotEditable } = useDealNotEditableHandler();
  const setDeal = useSetAtom(dealAtom);

  const [updateDealSetupNoteMutation, { loading, error, data }] = useMutation(
    UpdateDealSetupNoteDocument
  );

  const updateSetupNote = async (setupNote: string) => {
    const result = await updateDealSetupNoteMutation({
      variables: {
        dealId,
        setupNote,
      },
    });

    const payload = result.data?.updateDealSetupNote;
    if (payload?.__typename === 'DomainException') {
      handleIfDealNotEditable(payload.code);
      return { success: false };
    }

    const success = payload?.__typename === 'MutationSuccess';
    if (success) {
      setDeal((prev) => (prev ? { ...prev, setupNote } : null));
    }
    return { success };
  };

  return { updateSetupNote, loading, error, data };
}
